var SecureMessageView = require('./../secure-message/SecureMessageView');
var secureMessageBillTemplate = require('./secureMessageBillTemplate.hbs');
var viewUtils = require('./../utils/viewUtils');
var applicationUtils = require('./../applicationUtils');
var financialFeatureService = require('./../financial/financialFeatureService');

/**
 * @class SecureMessageBillView
 * @constructor
 * @param option {Object}
 *   @param options.model {Torso.Model}
 *   @param options.context.patientVecnaId {String}
 */
module.exports = SecureMessageView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--border brec-list__item--multi-linked',
  template: secureMessageBillTemplate,

  prepareFields: {
    currentApplication: applicationUtils.currentApplication
  },

  /**
   * Adds attributes to the the top level element (this is to support existing behavioral tests that query these values).
   * This only works because, as an item view, this view will only be created when the model already exists.  Values will not
   * be updated dynamically if they change for this view after it renders.
   * @returns {{status: String, bill-id: String, data-bill-external-id: String}} the bill status, id and external id.
   */
  attributes: function() {
    return {
      status: this.model.get('billDTO.externalBill.status'),
      'bill-id': this.model.get('servicesId'),
      'data-bill-external-id': this.model.get('billDTO.externalBill.externalId')
    };
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    SecureMessageView.prototype.initialize.call(this, options);
    this.listenTo(this.viewState, 'change:ableToPay change:hasAccountNumber', this.checkPaymentAllowed);
    this.listenTo(this.viewState, 'change:paymentAllowed', this.render);
    this.checkAccountNumber();
  },

  /**
   * @method postrender
   * @override
   */
  postrender: function() {
    viewUtils.updateViewElAttributes(this);
  },

  /**
   * Check payment allowed
   */
  checkPaymentAllowed: function() {
    var hasAccountNumber = this.get('hasAccountNumber');
    var patientPaymentAllowed = hasAccountNumber && financialFeatureService.patientPaymentAllowed(this.patientVecnaId);
    var adminPaymentAllowed = financialFeatureService.adminPaymentAllowed();
    this.set('paymentAllowed', patientPaymentAllowed || adminPaymentAllowed);
  },

  /**
   * Set ableToPay
   * @param ableToPay whether a payment can be made on this bill
   */
  setAbleToPay: function(ableToPay) {
    this.set('ableToPay', ableToPay);
  },

  /**
   * Check whether the bill has account number, the bill is only payable with account number
   * @method _checkAccountNumber
   * @private
   */
  checkAccountNumber: function() {
    var hasAccountNumber = !!this.model.get('billDTO.accountNumber');
    this.set('hasAccountNumber', hasAccountNumber);
  }
});
